// booking/components/FormCheckbox.jsx
import React, { memo } from 'react';
import { FormControlLabel, Checkbox } from '@mui/material';

const FormCheckbox = memo(({ label, background, checked = false, onChange, ...props }) => {
  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={checked}
          onChange={onChange}
          sx={{
            '&.Mui-checked': {
              color: background,
            },
          }}
          {...props}
        />
      }
      label={label}
    />
  );
});

FormCheckbox.displayName = 'FormCheckbox';

export default FormCheckbox;
